import styled from 'styled-components';
import {BGImageCenter} from '../../../../globalVariables/GlobalVariables';
import {uploadLight} from '../../../../assets/symbols/symbols/brandingIcons';
import {emailImage} from '../../../../pages/branding/emailScreen/EmailScreen.css';

interface EmailImageProps {
    color?: string;
    height?: string;
}

interface ImageProps {
    image?: string;
}

export const wrapImage = styled(emailImage)<EmailImageProps>`
    margin-bottom: 20px;
    margin-top: 10px;
`;

export const image = styled.div<ImageProps>`
    position: absolute;
    border-radius: 10px;
    width: 240px;
    height: 100%;
    margin: 0 calc(50% - 120px);
    ${p => BGImageCenter(p.image, 'cover')}
`;

export const uploadIcon = styled.div`
    width: 20px;
    height: 20px;
    ${BGImageCenter(uploadLight, 'contain')}
    position: absolute;
    bottom: 7px;
    inset-inline-end: 35px;
    pointer-events: none;
`;